import React, { Component } from 'react';
import cogoToast from 'cogo-toast';
import { AsYouType } from 'libphonenumber-js';
import * as htmlToImage from 'html-to-image';

import VacacionalTableEdit from './VacacionalTableEdit';
import ModalBorrar from '../modals/modalDelete';
import { Consumer } from "../../context";
import DinamicModal from '../dinamicModal/dinamicModal';

import Request from "../../core/httpClient";
const request = new Request();

class VacacionalHistoryTable extends Component {
	constructor(props) {

		super(props);

		this.state = {
			invitado: {}
		};
	};

	openModal(idModal, invitado) {

		this.setState({ invitado, id_invitado_row: invitado.id_frecuente_invitacion });

		const modal = document.getElementById(idModal);

		if (modal) {
			modal.classList.remove('hide-dinamic-modal');
			modal.classList.add('show-dinamic-modal');
		};

		document.getElementById('nom').focus();
	};

	openModalDelete(inv) {

		this.setState({ id_frecuente_invitacion: inv.id_frecuente_invitacion, id_invitado_row: inv.id_frecuente_invitacion });

		let modal = document.getElementById("deleteModal");

		if (modal) {
			modal.classList.remove('hide-modal');
			modal.classList.add('show-modal');
		};
	};

	async handleDelete(id, close) {

		let user = this.props.context.user.id.usuario;

		let data = {
			id_frecuente_invitacion: id,
			usuario: user
		};

		const response = await request.post('/invitadosFrecuentes/invitados/borrar', data);

		if (response) {

			if (response.deleted) {
				cogoToast.success('Invitado eliminado.', { position: 'bottom-right', });
			} else {
				cogoToast.error('No se pudo eliminar invitado.', { position: 'bottom-right', });
			};

		} else {
			cogoToast.error('No se pudo eliminar invitado.', { position: 'bottom-right', });
		};

		this.props.reload();

		if (close) {
			close();
		};
	};

	getNumberFormat(cell_phone, oculto) {
		try {

			if (oculto)
				return `******${cell_phone.substring(cell_phone.length - 4)}`;

			if (cell_phone.includes('+'))
				return new AsYouType('MXN').input(cell_phone);

			return new AsYouType('MXN').input('+' + cell_phone);

		} catch (error) {
			return null;
		};
	};
	async saveimg(invitado) {
		const inv = this.state.invitado;


		const scale = 2;
		const width = 400;
		const padding = 24;
		const qrSize = 250;
		const lineHeight = 28;
		const fontSize = 16;


		const lines = [
			`Nombre: ${inv.invitado ?? ''}`,
			`Vivienda: ${inv.numero_registro ?? ''}`,
			
		];


		const textBlock = lines.length * lineHeight;
		const height = padding + textBlock + 16 + qrSize + padding;


		const canvas = document.createElement('canvas');
		canvas.width = width * scale;
		canvas.height = height * scale;
		const ctx = canvas.getContext('2d');
		ctx.scale(scale, scale);


		ctx.fillStyle = '#ffffff';
		ctx.fillRect(0, 0, width, height);


		ctx.fillStyle = '#1a1a1a';
		ctx.font = `${fontSize}px Arial, sans-serif`;
		ctx.textAlign = 'center';
		ctx.textBaseline = 'middle';

		let y = padding + lineHeight / 2;
		lines.forEach((line) => {
			ctx.fillText(line, width / 2, y);
			y += lineHeight;
		});


		const qrUrl = `https://api.qrserver.com/v1/create-qr-code/?size=${qrSize}x${qrSize}&color=000000&bgcolor=F5F4F4&data=id_vivienda:${inv.id_vivienda}/id_frecuente_invitacion:${inv.id_frecuente_invitacion}`;

		try {
			const img = await new Promise((resolve, reject) => {
				const image = new Image();
				image.crossOrigin = 'anonymous';
				image.onload = () => resolve(image);
				image.onerror = reject;
				image.src = qrUrl;
			});

			const qrX = (width - qrSize) / 2;
			const qrY = padding + textBlock + 16;
			ctx.drawImage(img, qrX, qrY, qrSize, qrSize);


			const dataUrl = canvas.toDataURL('image/png');
			const a = document.createElement('a');
			a.href = dataUrl;
			a.download = `QR_Frecuente_temporal_${invitado}.png`;
			a.click();
		} catch (err) {
			console.log('[v0] Error generando QR:', err);
		}
	}


	render() {

		let invitados = []

		if (this.props.invitados) {
			invitados = this.props.invitados;
		};

		return (
			<div>
				<div className="table-responsiv column">
					<table>
						<thead className="sticky-th">
							<tr className="text-left">
								<th className="">
									<div className="row">
										Nombre &nbsp;
										<div className="align-center">
											{this.props.filterColumn.col === 'invitado' ? this.props.filterColumn.filt === 'asc' ?
												<i className="fas fa-sort-down" onClick={this.props.sortBy.bind(this, 'invitado')}></i>
												:
												<i className="fas fa-sort-up" onClick={this.props.sortBy.bind(this, 'invitado')}></i>
												:
												<i className="fas fa-sort" onClick={this.props.sortBy.bind(this, 'invitado')}></i>
											}
										</div>
									</div>
								</th>
								<th className="">Teléfono</th>
								<th className="">
									<div className="row">
										Vivienda &nbsp;
										<div className="align-center">
											{this.props.filterColumn.col === 'numero_registro' ? this.props.filterColumn.filt === 'asc' ?
												<i className="fas fa-sort-down" onClick={this.props.sortBy.bind(this, 'numero_registro')}></i>
												:
												<i className="fas fa-sort-up" onClick={this.props.sortBy.bind(this, 'numero_registro')}></i>
												:
												<i className="fas fa-sort" onClick={this.props.sortBy.bind(this, 'numero_registro')}></i>
											}
										</div>
									</div>
								</th>
								<th className="text-left">
									<div className="row">
										Acceso &nbsp;
										<div className="align-center">
											{this.props.filterColumn.col === 'acceso' ? this.props.filterColumn.filt === 'asc' ?
												<i className="fas fa-sort-down" onClick={this.props.sortBy.bind(this, 'acceso')}></i>
												:
												<i className="fas fa-sort-up" onClick={this.props.sortBy.bind(this, 'acceso')}></i>
												:
												<i className="fas fa-sort" onClick={this.props.sortBy.bind(this, 'acceso')}></i>
											}
										</div>
									</div>
								</th>
								<th className="text-center th-options-small">QR</th>
								<th className="text-center th-options-small">Editar</th>
								<th className="text-center th-options-small">Eliminar</th>
							</tr>
						</thead>
						<tbody>
							{invitados.slice((this.props.page - 1) * this.props.pageLength, this.props.page * this.props.pageLength).map((invitado, key) => (
								<tr className={`${this.state.id_invitado_row === invitado.id_frecuente_invitacion && 'row-active'}`} key={key}>
									<td>{invitado.invitado}</td>
									<td>{this.getNumberFormat(invitado.telefono, true)}</td>
									<td>{invitado.numero_registro}</td>
									<td>{invitado.acceso}</td>
									<td>
										<button
											className="btn-full justify-center btn-mini btn-secondary color-white"
											onClick={this.openModal.bind(this, "qrVacacional", invitado)}
										>
											<i className={`font-small fas fa-qrcode ${!invitado.activated && 'color-red'}`}></i>
										</button>
									</td>
									<td className="text-center">
										<button className="btn-full justify-center btn-mini btn-secondary color-white" type="button justify-center" onClick={this.openModal.bind(this, "editVacacional", invitado)}>
											<i className="font-small fas fa-pen" />
										</button>
									</td>
									<td>
										<button className="btn-full justify-center align-center btn-mini btn-secondary color-white"
											type='button' onClick={this.openModalDelete.bind(this, invitado)}
											style={{ padding: '5px' }}
											disabled={!this.props.escritura}
										>
											<i className="font-text fas fa-trash-alt " />
										</button>
									</td>
								</tr>
							))}
						</tbody>
					</table>
				</div>
				{<VacacionalTableEdit
					reload={this.props.reload.bind(this)}
					invitado={this.state.invitado}
					escritura={this.props.escritura}
					getNumberFormat={this.getNumberFormat.bind(this)}
				/>}
				<ModalBorrar
					id={this.state.id_frecuente_invitacion}
					delete={this.handleDelete.bind(this)}
				/>
				<DinamicModal
					idModal={'qrVacacional'}
					sizeModalContainer={'normal'}
					title={'Vacacional'}
				>
					<div className="column justify-center align-center full">
						<div
							id="qr-print"
							style={{
								backgroundColor: 'white',
								width: '400px',
								display: 'flex',
								flexDirection: 'column',
								alignItems: 'center',
								justifyContent: 'flex-start',
								padding: '1rem'
							}}
						>
							<p style={{ margin: '4px 0', lineHeight: '1.4' }}>
								Nombre: {this.state.invitado.invitado}
							</p>
							<p style={{ margin: '4px 0', lineHeight: '1.4' }}>
								Vivienda: {this.state.invitado.numero_registro}
							</p>


							<div style={{ marginTop: '12px' }}>
								<img
									crossOrigin="anonymous"
									style={{ maxWidth: '100%', height: 'auto' }}
									alt="QR"
									src={`https://api.qrserver.com/v1/create-qr-code/?size=250x250&color=000000&bgcolor=F5F4F4&data=id_vivienda:${this.state.invitado.id_vivienda}/id_frecuente_invitacion:${this.state.invitado.id_frecuente_invitacion}`}
								/>
							</div>
						</div>


						<button
							type="button"
							className="btn btn-primary btn-small color-white"
							onClick={this.saveimg.bind(this, this.state.invitado.invitado)}
						>
							Descargar
						</button>
					</div>
				</DinamicModal>

			</div>
		);
	};
};

export default Consumer(VacacionalHistoryTable);